import { render, staticRenderFns } from "./LoadSvg.vue?vue&type=template&id=a6270218&scoped=true&"
import script from "./LoadSvg.vue?vue&type=script&lang=js&"
export * from "./LoadSvg.vue?vue&type=script&lang=js&"
import style0 from "./LoadSvg.vue?vue&type=style&index=0&id=a6270218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6270218",
  null
  
)

export default component.exports